import { WmChart, WmChartSlice } from "@watermarkinsights/ripple-react";
import { AiDataCaptureCaption } from "../AiDataCaptureCaption";
import type { PieChartPayload } from "../ai-chat-message-utils";

interface AiPieChartProps {
  payload: PieChartPayload;
}

export const AiPieChart = ({ payload }: AiPieChartProps) => {
  const { label, valueFormat, data } = payload;

  // Stable key ensures WmChart remounts with all slices present when data changes
  const stableChartKey = data.map((d) => `${d.legend}:${d.amount}`).join("|");

  return (
    <div className="tcw-chart-card">
      {label && <p className="tcw-chart-label">{label}</p>}
      <div className="tcw-chart-wrapper">
        <WmChart
          key={stableChartKey}
          chartType="doughnut3"
          label={label ?? "Pie Chart "}
          labelPosition="none"
          valueFormat={valueFormat ?? "percentage"}
        >
          {data.map((item, index) => (
            <WmChartSlice
              key={index}
              amount={String(item.amount)}
              legend={item.legend}
            />
          ))}
        </WmChart>
      </div>
      <AiDataCaptureCaption />
    </div>
  );
};
